"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputContentContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sds_1 = require("@squiz/sds");
const react_1 = require("react");
const ContentTextInput_1 = require("../../atoms/ContentTextInput/ContentTextInput");
const CopyButton_1 = require("../../atoms/CopyButton/CopyButton");
const OutputContentContainer = ({ content, isLoading, errorMessage, }) => {
    const copyContent = (0, react_1.useCallback)(() => {
        const htmlBlob = new Blob([content], { type: 'text/html' });
        const textBlob = new Blob([content], { type: 'text/plain' });
        navigator.clipboard.write([
            new ClipboardItem({
                'text/html': htmlBlob,
                'text/plain': textBlob,
            }),
        ]);
    }, [content]);
    return ((0, jsx_runtime_1.jsxs)("section", { className: "dxp-ctm-section", children: [(0, jsx_runtime_1.jsxs)("div", { className: "dxp-ctm-section__header", children: [(0, jsx_runtime_1.jsx)("h3", { children: "New" }), (0, jsx_runtime_1.jsx)(CopyButton_1.CopyButton, { disabled: isLoading || !!errorMessage?.length, onClick: copyContent })] }), isLoading && ((0, jsx_runtime_1.jsx)("div", { className: "dxp-ctm-section__spinner squiz-fte-scope squiz-fte-scope__editor squiz-fte-scope__editor--is-disabled squiz-fte-scope__editor--bordered", children: (0, jsx_runtime_1.jsx)(sds_1.Spinner, {}) })), !isLoading && (0, jsx_runtime_1.jsx)(ContentTextInput_1.ContentTextInput, { content: errorMessage?.length ? errorMessage : content })] }));
};
exports.OutputContentContainer = OutputContentContainer;
